import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state?.placementStatus || initialState;

export const selectPlacementStatus = createSelector([selectDomain], placementStatus => placementStatus);
